import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";
import BookingPanel from "@/components/BookingPanel";
import { resolveBookingMode } from "@/lib/booking/bookingMode";

// Native panel is lazy-loaded so the public (embed) bundle never pulls in the
// native/prototype code. Embed users fetch zero extra bytes.
const NativeBookingPanel = React.lazy(() => import("@/components/NativeBookingPanel"));

// Single mount point for the booking experience (B5.1 · B9). Production =
// embed (the Google iframe, real bookings). In non-production the resolver now
// defaults to NATIVE (B9 prepared public experience), so the public CTAs open
// the native panel — clearly marked as a demo — without any query param. Any
// failure falls back to embed. The public CTAs and BookingContext API are
// unchanged; this is the ONLY swap point.
// We read location.search so the mode re-resolves on every navigation (no
// sticky state): ?bookingMode=embed restores the iframe for this view, and
// losing the param reverts to the env default.
export default function BookingRouter() {
  const { search } = useLocation();
  let mode = "embed";
  try { mode = resolveBookingMode({ search }); } catch { mode = "embed"; }

  if (mode === "native") {
    return (
      <Suspense fallback={null}>
        <NativeBookingPanel />
      </Suspense>
    );
  }
  return <BookingPanel />;
}
